export default __webpack_public_path__ + "static/media/readingCat.d51dc16d.png";